import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { StarbaseModalDialogService, StarbaseModalOptions, StarbaseModalButton, StarbaseModalTypes } from 'starbase-modal-dialog';
import { Observable } from 'rxjs';
import { DataDisplayerBase } from '../data-displayer-base';

@Component({
  selector: 'app-qmcategories-display',
  templateUrl: './qmcategories-display.component.html',
  styleUrls: ['./qmcategories-display.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class QmCategoriesDisplayComponent extends DataDisplayerBase<Object> {
  @Input() editMode: boolean;
  @Output() removeAction = new EventEmitter();

  constructor(private modalSvc: StarbaseModalDialogService) {
    super();
    if (!this.data) {
      this.data = [];
    }
  }

  removeItem(item: Object) {
    this.enableConfirmRowModal('Are you sure you want to remove this item? This action can\'t be undone.', 'Item removed', 'Item not removed').subscribe(a => {
      if (a) {
        this.removeAction.emit(item['specificationCategoryUID']);
      }
    });
  }

  enableConfirmRowModal(msg: string, successMsg?: string, errorMsg?: string): Observable<boolean> {
    const m = new Observable<boolean>(obj => {
      const modal = new StarbaseModalOptions('Confirm', msg, [
        new StarbaseModalButton('Yes', () => {
          obj.next(true);
          this.modalSvc.closeModal(successMsg);
        }),
        new StarbaseModalButton('No', () => {
          obj.next(false);
          this.modalSvc.closeModal(errorMsg);
        }),
      ], StarbaseModalTypes.Warning);

      modal.dismissable = true;
      this.modalSvc.postModal(modal);
      });

      return m;
   }


}
